<template>
    <div class="form-group" v-bind:class="{'dark': this.getDesign() == 'black', 'white' : this.getDesign() == 'white'}">
        <label for="">{{ $t(this.field.name) }} <span v-if="field.isRequired">*</span></label>
        <input v-if="!noLabel" type="text" :placeholder="$t('Escribe aquí...')" v-model="value" v-bind:class="{'required-field': field.isRequired}" @change="changeField">
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';

    export default {
        name: "input-normal",
        props: ["field","experience","room","noLabel","start"],
        data() {
            return {
                value: '',
            }
        },
        computed: {
            ...mapGetters(['getDesign','getCheckout','getFieldItems'])
        },
        created() {
            if(this.field.value) {
                this.value = this.field.value;
            }

            let fieldTemp = this.getFieldItems({id_experience: this.experience, id_calendario : this.room,  start: this.start, title: this.field.name});
            if(fieldTemp) {
                this.value = fieldTemp.value;
            }

            this.changeField();
        },
        methods: {
            ...mapMutations(['updateItemField']),
            changeField: function () {

                const newField =  {
                    id: this.$uuid.v4(this.field.id),
                    name: this.field.name,
                    title: this.field.name,
                    value: this.value ? this.value: '',
                    amount: 0,
                    total: 0,
                    id_custom_fields_options: this.field.id_custom_fields_options
                };

                this.updateItemField({id_experience: this.experience, id_calendario : this.room, newField, start: this.start});

                if(this.getCheckout().id) {
                    this.$emit('change-field');
                }
            },
        }
    }
</script>
